/**
 * Formats the gift card number
 * adds a space every 4 digits
 * @param cardNumber - The card number string to format.
 * @returns A formatted card number string with spaces every 4 digits,
 * or an empty string if no card number is provided.
 *
 * @example
 * ```typescript
 * formatCardNumber('1234567890123456') // Returns: '1234 5678 9012 3456'
 * formatCardNumber('1234-5678-9012-3456') // Returns: '1234 5678 9012 3456'
 * formatCardNumber('1234 5678 9012 3456') // Returns: '1234 5678 9012 3456'
 * formatCardNumber('') // Returns: ''
 * formatCardNumber(undefined) // Returns: ''
 * ```
 */
export const formatCardNumber = (cardNumber?: string): string => {
  if (!cardNumber) return '';

  const cleanNumber = cardNumber.replace(/\D/g, '');

  return cleanNumber.replace(/(\d{4})(?=\d)/g, '$1 ');
};
